module.exports = __webpack_public_path__ + "img/bg-bottom.1e1a965e.png";